import React from 'react';
import * as classes from './Checkbox.module.css';
const Checkbox = ({ checked, name, value, id, onChange, disabled = false }) => {
  return (
    <div className={`${classes.checkbox} ${disabled ? classes.disabled : ''}`}>
      <label
        className={`${checked ? '' : classes.unselected} ${classes.label}`}
      >
        <input
          type="checkbox"
          id={id}
          name={value}
          value={value}
          onChange={() => onChange(!checked)}
          checked={checked}
          disabled={disabled}
        />
        {name}
      </label>
    </div>
  );
};

export default Checkbox;
